/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Artifacts_Multi_Project_HintInputs */



/**
* | output |
* | --- |
* | "These artifacts come from several projects. Choose where the new chat should live — the assistant can still read all of them." |
*
* @param {Home_Artifacts_Multi_Project_HintInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const home_artifacts_multi_project_hint = /** @type {((inputs?: Home_Artifacts_Multi_Project_HintInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Artifacts_Multi_Project_HintInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Diese Artefakte stammen aus mehreren Projekten. Wähle, in welchem Projekt der neue Chat liegen soll — der Assistent kann trotzdem alle lesen.")
	return /** @type {LocalizedString} */ ("These artifacts come from several projects. Choose where the new chat should live — the assistant can still read all of them.")
});